module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/exame-a4281fe40646583fa42700337ace6cb5.svg";